import { useQuery } from 'react-query'
import Bugsnag from '@bugsnag/js'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { getDashboardRequest } from 'services/api/dashboard'
import SkeletonLoading from './SkeletonLoading'
import RequestError from './RequestError'
import RequestSucess from './RequestSucess'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

import { ReactComponent as NoPending } from '../assets/no_request.svg'

const ActiveRequest = ({ match_sm, match_mobile_m, navigate, location }) => {
  const getData = async () => {
    const res = await getDashboardRequest()
    return res.data
  }

  const { data, isLoading, isError, error } = useQuery(['DashboardRequest'], getData, {
    onError: (error) => {
      Bugsnag.notify(error)
    },
  })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          backgroundColor: '#fff',
          width: '100%',
          borderColor: 'gray-line.main',
        }}
      >
        {isLoading ? (
          <SkeletonLoading num={4} />
        ) : isError ? (
          <RequestError error={error} />
        ) : data?.length > 0 ? (
          data.map((value, index) => (
            <RequestSucess
              key={value.id}
              value={value}
              index={index}
              data={data}
              match_sm={match_sm}
              match_mobile_m={match_mobile_m}
              navigate={navigate}
              location={location}
            />
          ))
        ) : (
          <AdxEmptyStateV2
            height="400px"
            icon={<NoPending width={90} height={90} />}
            title="No request yet"
            subtitle="Your pending requests will show up here"
          />
        )}
      </Box>
    </Box>
  )
}

export default ActiveRequest
